<template>
  <div class="msgWarning">
    <!-- 直播中 -->
    <!-- <div class="msgWarning">{{msgWarning}}</div> -->
    <!-- 直播未开始 -->
    <div v-if="playState=='0'" style="color:#EFEFEF">{{msgWarning}}</div>
    <!-- 直播已结束 -->
    <div v-if="playState=='3'" style="color:red">{{msgWarning}}</div>
  </div>
</template>

<script>
export default {
  name: "MsgWarning",

  props: {
    playState: {},
    PlayBackList: {}
  },

  watch: {
    playState(newVal) {
      console.log(newVal);
    }
  },

  computed: {
    //直播提醒
    msgWarning() {
      //直播未开始
      if (this.playState == "0") {
        return "该课程直播未开始";
      }

      //直播已经结束
      if (this.playState == "3") {
        return "该课程已结束，老师上传回放课可回看";
      }
    }
  }
};
</script>

<style lang='less' scoped>
.msgWarning {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 40px;
}
</style>